module.exports = __webpack_public_path__ + "static/media/icon-close_white.82d960fd.svg";